// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_SendEventMailDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_SendEventMailDialogOutput extends MatDialogDataBaseOutput {
	subject: string;
	message: string;
}

@Component({
	selector: "sim-send-event-mail-dialog",
	templateUrl: "./send-event-mail-dialog.component.html",
	styleUrls: ["./send-event-mail-dialog.component.scss"],
	standalone: false,
})
export class SendEventMailDialogComponent extends BasicMaterialDialog<
	SendEventMailDialogComponent,
	DialogData_SendEventMailDialogInput,
	DialogData_SendEventMailDialogOutput
> {
	public sendMailForm = new FormGroup({
		subject: new FormControl("", [Validators.required]),
		message: new FormControl(""),
	});
	public T = Translations;

	constructor(_injector: Injector) {
		super(_injector);
	}

	protected ok() {
		const {subject, message} = this.sendMailForm.value;
		this.close({
			action: "ok",
			subject,
			message,
		});
	}
}
